export default {
    "de": {
        "first_login": "Erster Login",
        "first_login_warning": "Du hast dich zum Ersten mal eingeloggt, bitte überprüfe und speichere dein Profil:",
        "changed_warning": "Dein Profil wurde von einem Administrator geändert, bitte überprüfe und speichere die neuen Daten:",
        "inactive_warning": "Dieses Benutzerkonto ist zur Zeit deaktiviert",
        "header": {
            "create_manager": "Neuen Projektleiter anlegen",
            "create_technician": "Neuen Monteur anlegen"
        },
        "contact": {
            "header": "Kontaktdaten"
        },
        "labels": {
            "firstname": "Vorname",
            "lastname": "Nachname",
            "email": "E-Mail",
            "birthdate": "Geburtsdatum",
            "tel_office": "Telefon Büro",
            "tel_mobile": "Telefon Mobil",
            "street": "Straße und Hausnummer",
            "postal_code": "PLZ",
            "city": "Ort",
            "country": "Land",
            "nationality": "Nationalität",
            "license_plate": "KFZ Kennzeichen",
            "id_card": "Passkopie",
            "work_permit": "Arbeitsbewilligung",
            "btn_file_select": "Datei auswählen"
        },
        "login": {
            "header": "Zugangsdaten",
            "save_success_message": "E-Mail erfolgreich geändert. Bitte klicke auf den Bestätigungslink der an die neue Adresse gesendet wurde.",
            "labels": {
                "email": "E-Mail",
                "change_password": "Passwort ändern",
                "password_current": "Aktuelles Passwort",
                "password_new": "Neues Passwort",
                "password_new_confirm": "Passwort bestätigen",
                "isadmin": "Ist Administrator",
                "role": "Rolle",
                "id_extern": "ERP Id"
            },
            "buttons": {
                "deactivate": "Benutzer deaktivieren",
                "activate": "Benutzer aktivieren"
            }
        },
        "docs": {
            "header": "Dokumente",
            "labels": {
                "btn_file_select": "Dateien hinzufügen",
                "btn_delete_file_title": "Datei löschen"
            },
            "no_value": "Keine Dokumente hochgeladen"
        },
        "skills": {
            "header": "Technisches Profil"
        },
        "notes": {
            "header": "Notizen zum Monteur",
            "no_value": "Keine Notizen eingetragen"
        },
        "absences": {
            "header": "Abwesenheiten",
            "no_value": "Keine Abwesenheiten eingetragen",
            "labels": {
                "reason": "Grund",
                "date_span": "Zeitraum"
            },
            "buttons": {
                "add": "Neue Abwesenheit"
            }
        },
        "jobs": {
            "finished": {
                "header": "Abgeschlossene Montagen"
            }
        },
        "windows": {
            "change_password": {
                "title": "Passwort ändern",
                "save_success_message": "Passwort erfolgreich geändert."
            },
            "profile_notes": {
                "title": "Notizen bearbeiten",
                "save_success_message": "Notizen erfolgreich gespeichert."
            }
        }
    },
    "en": {
        "first_login": "First Login",
        "first_login_warning": "This is your first login. Please check and save your Profile:",
        "changed_warning": "Your profile got changed by another user, please check and save your data:",
        "inactive_warning": "This user account is currently deactivated",
        "contact": {
            "header": "Contact information"
        },
        "labels": {
            "firstname": "First name",
            "lastname": "Last name",
            "email": "E-Mail",
            "birthdate": "Birthdate",
            "tel_office": "Telephone office",
            "tel_mobile": "Telephone mobile",
            "street": "Street and house number",
            "postal_code": "Postal Code",
            "city": "City",
            "country": "State",
            "nationality": "Nationality",
            "license_plate": "License plate",
            "id_card": "ID Card",
            "work_permit": "Work permit",
            "btn_file_select": "Select file"
        },
        "login": {
            "header": "Login credentials",
            "save_success_message": "E-Mail changed successfully. Please verify the change by clicking the link which has been sent to the new E-Mail address.",
            "labels": {
                "email": "E-Mail",
                "change_password": "Change password",
                "password_current": "Current password",
                "password_new": "New password",
                "password_new_confirm": "Confirm new password",
                "isadmin": "Is Admin",
                "role": "Role"
            },
            "buttons": {
                "deactivate": "Deactivate user",
                "activate": "Activate user"
            }
        },
        "docs": {
            "header": "Documents",
            "labels": {
                "btn_file_select": "Add files",
                "btn_delete_file_title": "Delete file"
            },
            "no_value": "No documents uploaded"
        },
        "skills": {
            "header": "Technical Profile"
        },
        "notes": {
            "header": "Notes",
            "no_value": "No notes recorded"
        },
        "absences": {
            "header": "Absences",
            "no_value": "No absences registered",
            "labels": {
                "reason": "Reason",
                "date_span": "Date span"
            },
            "buttons": {
                "add": "New absence"
            }
        },
        "windows": {
            "change_password": {
                "title": "Change Password",
                "save_success_message": "Password changed successfully."
            },
            "profile_notes": {
                "title": "Edit notes",
                "save_success_message": "Notes saved successfully."
            }
        }
    }
}
